import React from 'react'
import { TextField, TextFieldProps } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { FormSectionContent } from '@modules/requirement/requirement-form/form-section-content.component'
import { FormSection } from '@modules/requirement/requirement-form/form-section.component'

interface RequirementTextFieldProps extends Omit<TextFieldProps, 'name'> {
  name: string
  editable?: boolean
  label: string
}

export const RequirementTextField: React.FC<RequirementTextFieldProps> = ({
  name,
  editable,
  label,
  ...textFieldProps
}) => {
  const { register, watch } = useFormContext()

  if (!editable) {
    return (
      <FormSection title={label}>
        <FormSectionContent content={watch(name) || ''} />
      </FormSection>
    )
  }

  return (
    <TextField
      {...register(name)}
      fullWidth
      multiline
      maxRows={20}
      margin="normal"
      InputLabelProps={{
        shrink: true,
      }}
      variant="outlined"
      label={label}
      {...textFieldProps}
      sx={{
        '& .MuiInputBase-input': {
          resize: 'vertical',
        },
      }}
    />
  )
}
